import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import routes from './routes'
import { getUserInfo } from '@/api/login'
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to: any, from: any, savedPosition: any) {
    return { top: 0 }
  }
})

router.beforeEach(async (to: any, from: any, next: any) => {
  const { userInfo }: any = store.state
  if (userInfo.token) {
    // 获取用户信息
    // await store.dispatch('userInfo/getUserInfo')
    let res: any = await getUserInfo()
    if (res.code == 200) {
      store.commit('userInfo/setUserInfo', res.data)
    }
  }
  next()
})

export default router
